import * as runtypes from 'runtypes';

export const UnitsSystemRuntime = runtypes.Literal('metric').Or(runtypes.Literal('imperial'));
export type UnitsSystem = runtypes.Static<typeof UnitsSystemRuntime>;
